import { Modal } from 'react-bootstrap'
import { PencilFill } from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import { CustomButton } from '../../../components/CustomButton'
import { ContentProduct, Footer, Header, Main } from './styles'

export function ModalDad({ isOpen, onClose, dad }) {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      title="Produto Pai"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Produto Pai</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <ContentProduct>
            <Header>
              <h1>
                ID: <strong>{dad?.codproduto}</strong> | SKU:{' '}
                <strong>{dad?.sku}</strong>
              </h1>
            </Header>

            <Main>
              <h1>{dad?.descricao}</h1>
            </Main>

            <Footer>
              <Link
                target="_blank"
                to={`/produtos/${dad.codproduto}`}
              >
                <CustomButton title="Editar">
                  <PencilFill />
                </CustomButton>
              </Link>
            </Footer>
          </ContentProduct>
        </div>
      </Modal.Body>
    </Modal>
  )
}
